import { useCallback } from "react";
import {
    ClientsWorkOverviewSortValue,
    ClientsWorkOverviewView,
} from "@common/types/views/clientsWorkOverviewView";
import { getWorkViewSort, withWorkViewSort } from "./workViewSort";

interface UseWorkViewSortParams {
    view: ClientsWorkOverviewView;
    setView: (
        update: (prev: ClientsWorkOverviewView) => ClientsWorkOverviewView,
    ) => void;
    onSortChange: () => void;
}

/** The Work page's sort, read from and written to the current view. */
export function useWorkViewSort({
    view,
    setView,
    onSortChange,
}: UseWorkViewSortParams) {
    const sort = getWorkViewSort(view);

    const handleSortChange = useCallback(
        (newSort: ClientsWorkOverviewSortValue) => {
            setView((prev) => withWorkViewSort({ view: prev, sort: newSort }));
            onSortChange();
        },
        [setView, onSortChange],
    );

    return { sort, handleSortChange };
}
